import styled from "styled-components/native";
import { VDBText } from "..";
import { SpaceType } from "../Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { css } from "styled-components/native";
import { getBoxShadow } from "@utils/product/productValidators";
import { DefaultTheme } from "styled-components/native";
import { ProductCategory } from "@utils/constants";
import { getProductThemeFromType } from "@components/common/Header/utils";

type TabSectionButtonProps = {
  name: string;
  onPress: () => void;
  title: string;
  isSelected: boolean;
  icon: { data: string; type: string };
  productType: ProductCategory;
};

const TabSectionButton = ({
  name,
  onPress,
  title,
  isSelected,
  icon,
  productType,
}: TabSectionButtonProps) => {
  const { theme, typography, t } = useScreenOptionsHooks();
  const productTheme = getProductThemeFromType(productType);
  return (
    <Container
      isSelected={isSelected}
      productTheme={productTheme}
      onPress={onPress}
    >
      {icon?.type === "url" ? (
        <VDBIcon
          name={undefined}
          uri={icon?.data}
          size={theme.isLargeScreen ? 24 : 20}
          color={theme["core-06"]}
          variant={IconsVariant.CustomUrl}
        />
      ) : (
        <VDBIcon
          name={icon?.data}
          size={theme.isLargeScreen ? 24 : 20}
          color={theme["core-06"]}
          variant={IconsVariant.VDBCustom}
        />
      )}
      <VDBText
        textAlign={"center"}
        type={typography["H3-M"]}
        color={theme["core-05"]}
      >
        {t(title)}
      </VDBText>
      {name === "vdb_ai_search" && (
        <BetaTextView>
          <VDBText
            type={typography["Minor-R"]}
            color={theme["core-06"]}
            style={{ fontStyle: "italic" }}
          >
            {t("chatbot.beta.text", "Beta")}
          </VDBText>
        </BetaTextView>
      )}
    </Container>
  );
};

export default TabSectionButton;

const Container = styled.Pressable<{
  isSelected: boolean;
  productTheme: string;
}>`
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-01"]};
  border-radius: ${SpaceType.Double * 2}px;
  border-color: ${({
    theme,
    isSelected,
    productTheme,
  }: {
    theme: DefaultTheme;
    isSelected: boolean;
    productTheme: string;
  }) =>
    isSelected
      ? theme[`${productTheme}-01` as keyof DefaultTheme]
      : theme["core-03"]};
  border-width: ${({ isSelected }: { isSelected: boolean }) =>
    isSelected ? 2 : 1}px;
  height: 48px;
  padding: ${SpaceType.Basic}px ${SpaceType.Double}px;
  flex-direction: row;
  gap: ${SpaceType.Basic}px;
  justify-content: center;
  align-items: center;
  ${({ isSelected, theme }: { isSelected: boolean; theme: DefaultTheme }) =>
    isSelected &&
    css`
      box-shadow: ${getBoxShadow(theme.Shadows.Normal)};
    `}
`;

const BetaTextView = styled.View`
  margin-left: -4px;
  padding-bottom: ${SpaceType.Basic}px;
`;
